/** Logo-Dateien des Ordners `assets/brand` (`bright/logo.*` für den hellen, `dark/logo.*` für den dunklen Modus), nach Pfad → URL. Die Icons dort bindet `vite.config.ts` ein. */
const files = import.meta.glob('../assets/brand/*/logo.{png,svg,PNG,SVG}', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;

/** Datei `<set>/logo.svg` bzw. `<set>/logo.png` des Ordners (SVG hat Vorrang), sonst null. */
function find(set: 'bright' | 'dark'): string | null {
  for (const ext of ['svg', 'png']) {
    const hit = Object.entries(files).find(([path]) => path.toLowerCase().endsWith(`/${set}/logo.${ext}`));
    if (hit) return hit[1];
  }
  return null;
}

/** Logo der Seite je Modus (siehe assets/brand/README.md); fehlt eines, gilt das andere. */
export const brandLogo: { light: string | null; dark: string | null } = { light: find('bright'), dark: find('dark') };
